import type { Infer } from 'superstruct';
import {
	array,
	boolean,
	defaulted,
	number,
	object,
	optional,
	partial,
	record,
	string,
} from 'superstruct';

import {
	parsableInteger,
	stringDate,
	userString,
} from '@adflow/shared/util-superstruct';

import {
	AddFacebookAdAccountDto,
	ViewFacebookAdAccountDto,
} from './facebook-ad-account.dto';
import {
	AddFacebookCampaignTemplateDto,
	ViewFacebookCampaignTemplateDto,
} from './facebook-campaign-template.dto';
import { FacebookCustomAudienceTemplateDto } from './facebook-custom-audience.dto';

export const FacebookSavedAudienceTemplateDto = record(string(), string());
export const FacebookSavedPageTemplateDto = record(string(), string());
export const FacebookSavedProductCatalogTemplateDto = record(
	string(),
	object({ id: optional(string()), name: optional(string()) })
);
export const FacebookSavedProductSetTemplateDto = record(
	string(),
	object({ id: optional(string()), name: optional(string()) })
);

export type FacebookSavedAudienceTemplateDto = Infer<
	typeof FacebookSavedAudienceTemplateDto
>;
export type FacebookSavedPageTemplateDto = Infer<
	typeof FacebookSavedPageTemplateDto
>;

export const AddFacebookTemplateDto = object({
	id: optional(parsableInteger()),
	name: userString('validations:Required'),
	archived: defaulted(boolean(), false),

	savedAudiences: optional(FacebookSavedAudienceTemplateDto),
	savedPages: optional(FacebookSavedPageTemplateDto),
	savedProductCatalogs: optional(FacebookSavedProductCatalogTemplateDto),
	savedProductSets: optional(FacebookSavedProductSetTemplateDto),
	customAudiences: optional(FacebookCustomAudienceTemplateDto),

	adAccounts: optional(array(AddFacebookAdAccountDto)),
	campaignTemplates: optional(array(AddFacebookCampaignTemplateDto)),
});

export const ViewFacebookTemplateDto = object({
	id: number(),
	name: string(),
	createdById: number(),

	createdAt: stringDate(),
	updatedAt: stringDate(),
	archived: boolean(),
	salesforceImport: boolean(),

	savedAudiences: optional(FacebookSavedAudienceTemplateDto),
	savedPages: optional(FacebookSavedPageTemplateDto),
	savedProductCatalogs: optional(FacebookSavedProductCatalogTemplateDto),
	savedProductSets: optional(FacebookSavedProductSetTemplateDto),
	customAudiences: optional(FacebookCustomAudienceTemplateDto),

	adAccounts: optional(array(ViewFacebookAdAccountDto)),
	campaignTemplates: optional(array(ViewFacebookCampaignTemplateDto)),
});

export type ViewFacebookTemplateDto = Infer<typeof ViewFacebookTemplateDto>;

export type AddFacebookTemplateDto = Infer<typeof AddFacebookTemplateDto>;
export const EditFacebookTemplateDto = partial(AddFacebookTemplateDto);
export type EditFacebookTemplateDto = Infer<typeof EditFacebookTemplateDto>;
